/* assets/armonia-product-related.js
   "Si abbina con": se manca il metafield custom.abbinamenti, chiede a Shopify i prodotti suggeriti
   (stesso pattern di Dawn: ricarica la sezione con section_id) e sostituisce la lista.
   Prima prova i prodotti "complementari" (servono l'app Search & Discovery configurata),
   se sono vuoti ripiega sui "correlati", che Shopify calcola da solo.
   Se non c'e nulla: usa la lista di riserva dentro l'elemento (carrello), altrimenti sul sito nasconde la sezione
   e nell'editor mostra un messaggio. */
(function () {
  'use strict';
  if (customElements.get('armonia-related-fetch')) return;

  function load(url) {
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var track = doc.querySelector('.armonia-rail__track');
        return track && track.children.length ? track : null;
      })
      .catch(function () { return null; });
  }

  class ArmoniaRelatedFetch extends HTMLElement {
    connectedCallback() {
      if (this._done) return;
      this._done = true;
      var self = this;
      var url = this.dataset.url;
      if (!url) return;
      load(url)
        .then(function (track) {
          if (track) return track;
          return load(url.replace('intent=complementary', 'intent=related'));
        })
        .then(function (track) {
          if (track) {
            self.replaceWith(track);
            document.dispatchEvent(new CustomEvent('armonia:favorites-changed'));
          } else {
            self.empty();
          }
        });
    }
    empty() {
      /* Se la sezione ha già una lista di riserva dentro (es. carrello), usa quella */
      var fb = this.querySelector('.armonia-rail__track');
      if (fb && fb.children.length) {
        this.replaceWith(fb);
        document.dispatchEvent(new CustomEvent('armonia:favorites-changed'));
        return;
      }
      var sec = this.closest('[data-armonia-related]') || this.closest('[data-armonia-cart-related]');
      var design = !!(window.Shopify && window.Shopify.designMode);
      if (design) {
        var p = document.createElement('p');
        p.className = 'armonia-rail__empty';
        p.textContent = this.dataset.empty || '';
        this.replaceWith(p);
      } else {
        if (sec) sec.hidden = true;
        this.remove();
      }
    }
  }
  customElements.define('armonia-related-fetch', ArmoniaRelatedFetch);
})();
